import { useSearchParams } from "react-router-dom";

export function useRequestFormDraftId(): string {
  const [searchParams] = useSearchParams();
  return searchParams.get("draft_id") ?? "";
}
